module.exports = __webpack_public_path__ + "static/parade-2020-house37-cd123dd2253fb8d9040a1d50c61beb33.jpg";